import {
    ADD_CENTRO_MAQUINA,
    DELETE_CENTRO_MAQUINA,
    MODIFY_CENTRO_MAQUINA
} from '../constants/action_types';

export function addMaquinaCentro(centro) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_CENTRO_MAQUINA, payload: centro });
    };
};

export function modifyMaquinaCentro(centro) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_CENTRO_MAQUINA, payload: centro });
    };
};


export function removeMaquinaCentro(centro) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_CENTRO_MAQUINA, payload: centro });
    };
};